// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__FknwN","visible":"Reveal_visible__t5lGy"};